import { IngressRequest } from '@dispatch/shared/types';
import { useMutate } from '../api/useMutate';
import { ingressTask } from '@dispatch/shared/services';

export const useIngressRequest = (
  responseFn: (response: { success: boolean }) => void | Promise<unknown>
) => {
  const { mutate, error, status } = useMutate(
    ['ingress-request'],
    (data: { request: IngressRequest }) => ingressTask(data.request),
    (data) => {
      responseFn(data as { success: boolean; message?: string });
    }
  );

  return {
    ingressRequest: mutate,
    error,
    status,
  };
};
